import React from "react";
import { sanitiseString } from "../../Utils";

export interface Props {
  id: string;
  text?: string;
  url: string;
  dataTestId: string;
}

export const SkipToContent = (props: Props) => {
  return (
    <a
      className="ons-skip-to-content"
      href={props.url}
      id={sanitiseString(props.id)}
      data-testid={sanitiseString(props.dataTestId)}
    >
      {props.text || "Skip to content"}
    </a>
  );
};
